/**
 * @file: Permission.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 权限管理
 */
import request from '@/utils/request'

/**
 * 中心登录日志列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionLoginlogList(data) {
  return request({
    type: 'biz',
    url: 'permission/loginlog/list',
    method: 'post',
    data
  })
}

/**
 * 获取权限模块新增时的模块列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionModuleAddList(data) {
  return request({
    type: 'biz',
    url: 'permission/module/add/list',
    method: 'post',
    data
  })
}

/**
 * 权限模块新增(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionModuleInsert(data) {
  return request({
    type: 'biz',
    url: 'permission/module/insert',
    method: 'post',
    data
  })
}

/**
 * 权限角色新增(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionRoleAdd(data) {
  return request({
    type: 'biz',
    url: 'permission/role/add',
    method: 'post',
    data
  })
}

/**
 * 权限角色删除(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionRoleDelete(data) {
  return request({
    type: 'biz',
    url: 'permission/role/delete',
    method: 'post',
    data
  })
}

/**
 * 获取权限角色信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionRoleGet(data) {
  return request({
    type: 'biz',
    url: 'permission/role/get',
    method: 'post',
    data
  })
}

/**
 * 获取权限角色列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionRoleList(data) {
  return request({
    type: 'biz',
    url: 'permission/role/list',
    method: 'post',
    data
  })
}

/**
 * 获取权限角色列表(无超级管理员)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionRoleNosuperList(data) {
  return request({
    type: 'biz',
    url: 'permission/role/nosuper/list',
    method: 'post',
    data
  })
}

/**
 * 权限角色更新(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionRoleUpdate(data) {
  return request({
    type: 'biz',
    url: 'permission/role/update',
    method: 'post',
    data
  })
}

/**
 * 中心用户管理列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionUserList(data) {
  return request({
    type: 'biz',
    url: 'permission/user/list',
    method: 'post',
    data
  })
}

/**
 * 用户登录，获取权限列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionUserLoginList(data) {
  return request({
    type: 'biz',
    url: 'permission/user/login/list',
    method: 'post',
    data
  })
}

/**
 * 中心用户管理更新角色(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function permissionUserUpdate(data) {
  return request({
    type: 'biz',
    url: 'permission/user/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Permission.js